import { useMemo } from "react";
import dayjs from "dayjs";

export const useLabelData = ({ units, PID, PIN }) => {
  return useMemo(() => {
    let total = 0;
    let noRmin = Infinity;
    let noRmax = 0;
    let rMinSize = Infinity;
    let rMaxSize = 0;

    let mDate = null;
    let foundToday = false;
    const today = dayjs().startOf("day");

    let sales = false;
    let rental = false;

    for (const unit of units) {
 
      const val = unit?.Data;
      if (!val) continue;

      // total units
      if (val?.ProjectID?.Value === PID) total++;

      // rooms
      const rooms = val?.VaerelserAntal?.Value;
      if (rooms != null) {
        noRmin = Math.min(noRmin, rooms);
        noRmax = Math.max(noRmax, rooms);
      }

      // size
      const size = val?.Areal?.Value;
      if (size) {
        rMinSize = Math.min(rMinSize, size);
        rMaxSize = Math.max(rMaxSize, size);
      }

      // move-in date
      const cuDate = val?.Indflytningsdato?.Value;
      const sID = val?.UnitStatusID?.Value;

      if (cuDate && sID === 10) {
        const moveIn = dayjs(cuDate, "DD-MM-YYYY");

        if (moveIn.isValid()) {
          if (moveIn.isSame(today, "day")) {
            mDate = moveIn;
            foundToday = true;
          } else if (!foundToday && moveIn.isAfter(today)) {
            if (!mDate || moveIn.isBefore(mDate)) {
              mDate = moveIn;
            }
          }
        }
      }
    
      // type
      if (val?.SalesTypeLejelejlighed?.Value) rental = true;
      if (val?.SalesTypeEjerlejlighed?.Value) sales = true;
    }

    return {
      totalUnits: total,
      noRmin: noRmin === Infinity ? null : noRmin,
      noRmax,
      rMinSize: rMinSize === Infinity ? null : rMinSize,
      rMaxSize,
      finalMdate: mDate ? mDate.format("DD-MM-YYYY") : null,
      saletype:
        sales && rental ? "leje & salg" : sales ? "salg" : "leje",
    };
  }, [units, PID, PIN]);
};